import { DrawerTitle } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import DrawerFormRenderer from "components/Forms/FormRenderers/DrawerFormRenderer";
import { GroupFormController } from "components/Forms/GroupForm";
import { DrawerContextLink } from "components/common/DrawerContextLink";
import { RoutedDrawer } from "components/common/RoutedDrawer";
import { injectModal } from "lib/injectParams";

const EditGroup: React.FC<{ id: string; clubId: string }> = ({ clubId }) => {
  const controller = GroupFormController.use();
  const { loading } = controller.state;
  const fields = Object.values(controller.fields());

  return (
    <RoutedDrawer spinner={loading}>
      <DrawerTitle contextLink={<DrawerContextLink context="groups" params={{ clubId }} />}>
        Edit group
      </DrawerTitle>
      <DrawerFormRenderer name="edit-group" fields={fields} />
    </RoutedDrawer>
  );
};

export default injectModal(GroupFormController.scope(ApplicationView(EditGroup)));
